import React, { useEffect, useMemo } from 'react';
import { useGetResultYearValueDropdownQuery } from '../services/api';

interface Props {
  grade: 10 | 12;
  value: number;
  onChange: (year: number) => void;
  label?: string;
}

const ResultYearDropdown: React.FC<Props> = ({
  grade,
  value,
  onChange,
  label = 'Year',
}) => {
  const { data: yearOptionsData } = useGetResultYearValueDropdownQuery({ grade });

  const yearOptions = useMemo(() => {
    const normalized = (yearOptionsData || [])
      .map((year) => Number(year))
      .filter((year) => Number.isFinite(year));

    if (normalized.length > 0) {
      return normalized;
    }

    return [value];
  }, [yearOptionsData, value]);

  useEffect(() => {
    if (!yearOptions.includes(value)) {
      onChange(yearOptions[0]);
    }
  }, [yearOptions, value, onChange]);

  return (
    <div className="bg-white rounded-xl border border-gray-200 px-4 py-3 flex items-center gap-3">
      <span className="text-sm font-medium text-gray-600 whitespace-nowrap">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-orange-200"
      >
        {yearOptions.map((year) => (
          <option key={year} value={year}>
            {year - 1}-{String(year).slice(-2)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ResultYearDropdown;